<template src="./index.html"></template>

<script>
import { URL, apiCall } from "@/utils/api";
export default {
  name: "UserSearch",
  props: ["type", "selUser", "clr"],
  data() {
    return {
      values: {
        pin: null,
        pinPrefix: "AZE",
        cardNo: null,
        firstName: null,
        lastName: null,
        fatherName: null,
        year: null,
        gender: null,
      },
      cardSerType: "PIN",
      cuser: null,
      searchLoading: false,
      customValidator: {
        pin: {
          status: "success",
          message: "",
        },
        cardNo: {
          status: "success",
          message: "",
        },
        firstName: {
          status: "success",
          message: "",
        },
        lastName: {
          status: "success",
          message: "",
        },
        fatherName: {
          status: "success",
          message: "",
        },
        year: {
          status: "success",
          message: "",
        },
        gender: {
          status: "success",
          message: "",
        },
      },
      cardSerType: "PIN",
      years: [],
    };
  },
  methods: {
    fillYears() {
      const currentYear = new Date().getFullYear();
      let years = [];
      for (let y = currentYear; y > currentYear - 100; y--) {
        years.push(y);
      }
      this.years = years;
    },
    handleCITypeChange(e) {
      if (e.target.value === "NAM") this.fillYears();
      this.cuser = null;
      this.$emit("found", null);
      this.clearValues();
      this.clearValidations();
    },
    clearValues() {
      this.values = {
        pin: null,
        pinPrefix: "AZE",
        cardNo: null,
        firstName: null,
        lastName: null,
        fatherName: null,
        year: null,
        gender: null,
      };
    },
    reset() {
      this.clearFields();
      this.clearValues();
      this.clearValidations();
    },
    handlePinChange(p) {
      if (p.length != 7) {
        this.clearFields(p);
      }
    },
    handleCardNoChange(e) {
      if (e.target.value)
        this.values.cardNo = e.target.value.replace(/[a-z\s]/giu, "");
    },
    clearFields(p) {
      this.cuser = null;
      this.$emit("clear");
    },
    handleSearchCitizen() {
      if (this.validateFields()) {
        let parameters = {};
        switch (this.cardSerType) {
          case "PIN":
            parameters = { pin: this.values.pin };
            break;
          case "PAS":
            parameters = {
              cardNo:
                this.values.pinPrefix === "AZE"
                  ? this.values.cardNo
                  : this.values.pinPrefix + this.values.cardNo,
            };
            break;
          case "NAM":
            parameters = {
              firstName: this.values.firstName,
              lastName: this.values.lastName,
              fatherName: this.values.fatherName,
              year: this.values.year,
              gender: this.values.gender,
            };
            break;
        }
        this.searchLoading = true;
        apiCall({
          url:
            URL[process.env.NODE_ENV].service_api +
            "citSearch/chuser/" +
            this.cardSerType,
          method: "GET",
          params: parameters,
        })
          .then((response) => {
            if (!response.data.error) {
              let ulist = response.data.data;
              if (ulist && ulist.length == 1) {
                this.cuser = ulist[0];
                this.setUserInfo();
              }
              this.$emit("found", ulist);
            } else this.$message.error(response.data.error.message);
            this.searchLoading = false;
          })
          .catch((err) => {
            this.$message.error("Xəta baş verdi");
            console.log(err);
            this.searchLoading = false;
          });
      }
    },
    validateFields() {
      let result = true;
      if (this.cardSerType === "PIN") {
        if (!this.values.pin) {
          this.customValidator.pin = {
            status: "error",
            message: "Zəhmət olmasa vətəndaşın fin kodunu daxil edin",
          };
          result = false;
        } else if (this.values.pin.length != 7) {
          this.customValidator.pin = {
            status: "error",
            message: "FİN 7 simvoldan ibarət olmalıdır",
          };
          result = false;
        } else {
          this.customValidator.pin = { status: "success", message: "" };
        }
      }
      if (this.type === "CITIZEN") {
        if (this.cardSerType === "PAS") {
          if (!this.values.pinPrefix) {
            this.customValidator.cardNo = {
              status: "error",
              message: "Zəhmət olmasa vətəndaşın seriyasını seçin",
            };
            result = false;
          } else if (!this.values.cardNo) {
            this.customValidator.cardNo = {
              status: "error",
              message: "Zəhmət olmasa vətəndaşın seriya nömrəsini daxil edin",
            };
            result = false;
          } else if (
            this.values.pinPrefix === "AZE" &&
            this.values.cardNo.length < 8
          ) {
            this.customValidator.cardNo = {
              status: "error",
              message:
                "Zəhmət olmasa vətəndaşın seriya nömrəsini tam daxil edin",
            };
            result = false;
          } else if (this.values.cardNo.length < 6) {
            this.customValidator.cardNo = {
              status: "error",
              message:
                "Zəhmət olmasa vətəndaşın seriya nömrəsini tam daxil edin",
            };
            result = false;
          } else {
            this.customValidator.cardNo = { status: "success", message: "" };
          }
        } else if (this.cardSerType === "NAM") {
          if (!this.values.firstName) {
            this.customValidator.firstName = {
              status: "error",
              message: "Zəhmət olmasa vətəndaşın adını daxil edin",
            };
            result = false;
          } else {
            this.customValidator.firstName = { status: "success", message: "" };
          }
          if (!this.values.lastName) {
            this.customValidator.lastName = {
              status: "error",
              message: "Zəhmət olmasa vətəndaşın soyadını daxil edin",
            };
            result = false;
          } else {
            this.customValidator.lastName = { status: "success", message: "" };
          }
          if (!this.values.fatherName) {
            this.customValidator.fatherName = {
              status: "error",
              message: "Zəhmət olmasa vətəndaşın ata adını daxil edin",
            };
            result = false;
          } else {
            this.customValidator.fatherName = {
              status: "success",
              message: "",
            };
          }
          if (!this.values.year) {
            this.customValidator.year = {
              status: "error",
              message: "Zəhmət olmasa vətəndaşın doğulduğu ili seçin",
            };
            result = false;
          } else {
            this.customValidator.year = { status: "success", message: "" };
          }
          if (this.values.gender == null) {
            this.customValidator.gender = {
              status: "error",
              message: "Zəhmət olmasa vətəndaşın cinsini seçin",
            };
            result = false;
          } else {
            this.customValidator.gender = { status: "success", message: "" };
          }
        }
      }
      return result;
    },
    setUserInfo() {
      if (!this.cuser.photo.startsWith("data"))
        this.cuser.photo = "data:image/png;base64," + this.cuser.photo;
    },
    handlePhoneKeyDown(e) {
      if (isNaN(Number(e.key))) e.preventDefault();
    },
    clearValidations() {
      this.customValidator = {
        pin: {
          status: "success",
          message: "",
        },
        cardNo: {
          status: "success",
          message: "",
        },
        firstName: {
          status: "success",
          message: "",
        },
        lastName: {
          status: "success",
          message: "",
        },
        fatherName: {
          status: "success",
          message: "",
        },
        year: {
          status: "success",
          message: "",
        },
        gender: {
          status: "success",
          message: "",
        },
      };
    },
  },
  watch: {
    selUser: function (newValue, oldValue) {
      this.cuser = this.selUser;
      this.setUserInfo();
    },
    clr: function (newValue, oldValue) {
      if (newValue) {
        this.cuser = null;
        this.$emit("cleared");
      }
    },
  },
  mounted() {},
};
</script>

<style scoped src="./index.scss" lang="scss"></style>
